export const requestHostInterceptor = defaultHost => client => async action => {
  const savedAuth = localStorage.getItem('auth');
  let accessToken = '';
  let idToken = '';
  let prefix = '/starter-api';
  
  let host = defaultHost;
  
  if (action.host) {
    host = action.host;
  }

  if (action.prefix) {
    prefix = action.prefix.trim()
  }
  
  if (savedAuth) {
    const auth = JSON.parse(savedAuth);
    accessToken = auth?.accessToken;
    idToken = auth?.idToken;
  }

  return {
    ...action,
    endpoint: `${host}${prefix}${action.endpoint}`,
    headers: {
      ...action.headers,
      "Authorization": `Bearer ${accessToken}`,
      "id_token": idToken,
      "response-type": "json",
      "X-Trato-Source": "plugin"
    },
  };
};

export const axiosRequestHostInterceptor = defaultHost => async action => {
  const savedAuth = localStorage.getItem('auth');
  let accessToken = '';
  let idToken = '';
  
  let host = defaultHost;
  let prefix = '/starter-api';
  
  if (action.host) {
    host = action.host;
  }

  if (action.prefix) {
    prefix = action.prefix.trim()
  }

  if (savedAuth) {
    const auth = JSON.parse(savedAuth);

    accessToken = auth?.accessToken;
    idToken = auth?.idToken;
  }

  if (action.prefix) {
    prefix = action.prefix.trim()
  }

  return {
    ...action,
    url: `${host}${prefix}${action.endpoint}`,
    data: action.body,
    headers: {
      ...action.headers,
      "Authorization": `Bearer ${accessToken}`,
      "id_token": idToken,
      "response-type": "json",
      "X-Trato-Source": "plugin"
    },
  };
};